@if (showDialog) {
  <dx-popup
    [height]="auto"
    [showCloseButton]="true"
    [showTitle]="true"
    [title]="caption"
    [dragEnabled]="false"
    class="popup-qr-code"
    [closeOnOutsideClick]="true"
    [(visible)]="showDialog"
    animation="{ show:'duration:400'}">
    <div *dxTemplate="let data of 'content'">
      <div>
        <ngx-qrcode
          [elementType]="elementType"
          [value]="messangerUrl"
          cssClass="aclass d-block"
          class="d-block"
          errorCorrectionLevel="L"></ngx-qrcode>
        <div class="popup-qr-code__scan_open" id="{{ messangerUrl }}">
          {{ 'SCAN' | translate }}
        </div>
        <a [href]="messangerUrl" target="_blank" class="popup-qr-code__scan_link">
          <div>
            <i class="mdi mdi-open-in-new"></i>
            {{ 'OPEN' | translate }}
          </div>
        </a>
      </div>
      <dx-button class="btn btn-close" title="{{ 'CLOSE' | translate }}" icon="mdi mdi-close-circle" (onClick)="onCancel()"></dx-button>
    </div>
  </dx-popup>
}
